import { render, staticRenderFns } from "./AccountTransactionInfo.vue?vue&type=template&id=4c8efbca&"
import script from "./AccountTransactionInfo.vue?vue&type=script&lang=js&"
export * from "./AccountTransactionInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports